// 省電力: 操作が無いまま時間がたったら、描画を間引き(low)、さらにたつと止める(sleep)。
// タイトルの見本の試合・結果・ポーズなど、見ているだけの画面で電池と発熱を抑えるため(2026-10-31 オーナー要望)。
// 試合中とリプレイの再生中は keepAwake で対象外にする(操作が無くても見ている・遊んでいるため)。
// 秒数は config.powerSave。ここは時刻だけで決める小さな部品(描画・画面は src/main.js が持つ)。
// 試合の計算(src/sim/)には関わらないので、ここでは時刻を使ってよい。

export function createPowerSave({ lowAfterSeconds, lowFps, sleepAfterSeconds }, now = 0) {
  let lastActive = now;
  let lastDraw = -Infinity;
  let state = "awake"; // awake | low | sleep

  return {
    get state() {
      return state;
    },
    // 操作があった。眠っていたら起こす(戻り値: 眠っていたか)
    poke(t) {
      const wasAsleep = state === "sleep";
      lastActive = t;
      lastDraw = -Infinity;
      state = "awake";
      return wasAsleep;
    },
    // 毎フレーム呼ぶ。今の状態を決める(keepAwake のあいだは操作があったものとして数え直す)
    update(t, keepAwake) {
      if (keepAwake) lastActive = t;
      if (state === "sleep") return state;
      const idle = (t - lastActive) / 1000;
      state = idle >= sleepAfterSeconds ? "sleep" : idle >= lowAfterSeconds ? "low" : "awake";
      return state;
    },
    // このフレームを描くか(low のときは lowFps まで間引く)
    shouldDraw(t) {
      if (state === "sleep") return false;
      if (state === "low" && t - lastDraw < 1000 / lowFps - 1) return false;
      lastDraw = t;
      return true;
    },
  };
}
